<template>
  <div class="WelfareTreatment">
    <ComTitlte titleEn="BENEFITS" titleZh="福利待遇"></ComTitlte>
    <div class="cont">
      <div class="c_left wow slideInLeft">
        事务所依据国家法律及地方法规之规定，与聘请的员工签订劳动合同，缴纳五险一金，享受带薪休假、工作津贴、体检、培训等员工福利。工资薪酬由基本工资、岗位工资、绩效工资和补贴（含交通、通讯、餐费）等构成，具体薪酬视个人能力和工作经验面议。
      </div>
      <div class="c_right wow slideInRight">
        <img src="../../assets/img/recruit/b_img1.png" alt="..." />
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "WelfareTreatment",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  components: { ComTitlte },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.WelfareTreatment {
  width: $themeMinWidth;
  margin: 0 auto;
  position: relative;
  .cont {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 30px 0 0 0;
    .c_left {
      width: 580px;
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 0px;
      color: #666666;
      background-color: #ffffff;
      box-shadow: 2px 3px 7px 0px rgba(0, 0, 0, 0.19);
      padding: 30px;
      box-sizing: border-box;
      text-indent: 32px;
    }
    .c_right {
      width: 560px;
      height: 180px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
